/*
 * 共通関数
 * コンポーネントで使用するにはmixinsで読み込む
 * import cf from '@/mixins/commonFunctions';
 * mixins: [cf],
 */

import moment from 'moment';
import axios from '@/plugins/axios';
import { cloneDeep } from 'lodash';

const GlobalMenuItems = [
  // [0]はHomeで固定
  {
    name: 'history',
    label: '本日の履歴',
    icon: 'fa-solid fa-history',
    path: '/history/',
  },
  {
    name: 'request',
    label: '依頼',
    icon: 'fa-solid fa-volume',
    path: '/request/',
  },
  {
    name: 'home',
    label: 'ホーム',
    icon: 'fa-solid fa-house',
    path: '/',
  },
  {
    name: 'order',
    label: '配車',
    icon: 'fa-solid fa-file',
    path: '/order/',
  },
  {
    name: 'setting',
    label: '設定',
    icon: 'fa-solid fa-gear',
    path: '/setting/',
  },
];

export default {
  /**
   * localStorage[${key}]の値を返却
   * @param  str key localStorageの対象キー
   * @return obj jsonパース済みオブジェクト
   */
  getLocalStorage(key) {
    let result;
    if (localStorage && localStorage[key]) {
      result = JSON.parse(localStorage[key]);
    }
    return result;
  },


  /**
   * ローカルストレージに保存
   * @param obj 既存データにマージしたいオブジェクト
   * @param str key localStorageの対象キー
   */
  saveLocalStorage(obj, key = '') {
    if (!key) return;
    const ls = this.getLocalStorage(key);
    const save = ls ? { ...ls, ...obj } : obj;
    const stringify = JSON.stringify(save);
    localStorage.setItem(key, stringify);
  },


  /**
   * localStorage削除
   * @param key localStorageから削除するキー
   */
  deleteLocalStorage(key, key2 = null) {
    if (!key) return;
    if (localStorage[key]) {
      if (!key2) {
        localStorage.removeItem(key);
        console.log(`localStorage[${key}]を削除しました`);
      } else {
        // 特定の子階層のみを削除

        // 指定キー以外を一時ストック
        const stock = {};
        const target = JSON.parse(localStorage[key]);

        const keys = Object.keys(target);
        for (let i = 0; i < keys.length; i += 1) {
          const k = keys[i];
          if (k !== key2) stock[k] = target[k];
        }
        // 一度localstorage[key]ごと削除して
        localStorage.removeItem(key);
        // ストックしておいたkey2の除外データを保存
        this.saveLocalStorage(stock, key);
        console.log(`localStorage[${key}]の[${key2}]を削除しました`);
      }
    } else {
      console.log(`localStorage[${key}]は存在しません`);
    }
  },

  /**
   * 桁数を合わせる
   */
  zeroPadding(num, len) {
    return (Array(len).join('0') + num).slice(-len);
  },


  /** Formコンポーネントに渡す配列をkey=name、value=valueのオブジェクトに変換 */
  pullOutValues(items) {
    const obj = {};
    items.forEach((item) => {
      if (!item.name || !item.value) {
        throw new Error('Item must have "name" and "value" properties');
      }
      obj[item.name] = item.value;
    });
    return obj;
  },

  getMenuItems() {
    return GlobalMenuItems;
  },

  getPage(path) {
    return GlobalMenuItems.find((item) => item.path && path === item.path) || GlobalMenuItems[0];
  },

  getStatusItems(master) {
    if (!master) return [];
    const arr = [
      ...master.orders.flags.filter((flag) => flag.isValid).map((flag) => Object({ ...flag, itemType: 'orderFlag' })),
      ...master.driverActivities.items.map((item) => Object({ ...item, itemType: 'driverActivity' })),
    ];
    return arr;
  },

  // 緯度経度から住所取得
  async getAddressByLatLng({ lat, lng }) {
    const result = {};
    await axios({
      method: 'GET',
      url: '/v1/helper/get/address',
      params: {
        lat,
        lng,
      },
    })
      .then((response) => {
        const res = response.data;
        result.title = res.title;
        result.address = res.address;
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  },

  /**
   * 北東端と南西端から得られる長方形に含まれるか判定
   * @param {Array} northeast 北東端の緯度経度
   * @param {Array} southwest 南西端の緯度経度
   * @param {Array} point 対象の緯度経度
   * @return {Boolean} 範囲内にあるかどうか
   * */
  isWithinBounds(northeast, southwest, point) {
    const [neLat, neLng] = northeast;
    const [swLat, swLng] = southwest;
    const [pointLat, pointLng] = point;

    // 緯度と経度が範囲内にあるかどうかを判定
    const withinLat = swLat <= pointLat && pointLat <= neLat;
    const withinLng = swLng <= pointLng && pointLng <= neLng;

    return Boolean(withinLat && withinLng);
  },


  /**
   * ネイティブアプリのバッジを更新するトリガー
   * @param {*} helper
   */
  updateNativeAppBadges(helper) {
    if (helper.isNative.app) {
      // ネイティブアプリに限る
      const native = helper.isNative;
      const data = { command: 'badgeUpdate' };
      if (native.android) {
        const Android = window.Android;
        Android.jsToAndroid(JSON.stringify(data));
      } else if (native.iOS) {
        console.log(this.helper.isNative);
      }
    }
  },


  /**
   * ネイティブアプリの位置情報取得を開始・停止
   * @param {*} helper
   */
  ToggleNativeAppLocation(helper, next = 1) {
    if (helper.isNative.app) {
      const native = helper.isNative;
      const type = next === 1 ? 'START' : 'STOP';
      const data = { command: 'toggleLocation', type };
      if (native.android) {
        const Android = window.Android;
        Android.jsToAndroid(JSON.stringify(data));
      } else if (native.iOS) {
        console.log(this.helper.isNative);
      }
    }
  },


  /**
   * 【重要】
   * コンポーネントで直接使用するには
   * methodsオブジェクトに入れておく必要がある
  */
  methods: {
    parseNewlinesToBr(text) {
      return text.replace(/(\r\n|\n|\r)/g, '<br>');
    },
    /** タイムスタンプのフォーマット */
    formatTimestamp(stamp, format = 'YYYY-MM-DD') {
      let result = moment(stamp, 'X').format(format);
      if (!String(stamp).includes('GMT')) {
        result = moment(stamp).format(format);
      }
      return result;
    },

    /** 住所から郵便番号削除 */
    removeZipPref(address) {
      if (!address) return '--';
      const prefs = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '長野県', '新潟県', '富山県', '石川県', '福井県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'];
      // zip部分を削除
      const splited = address.split(' ');
      let newStr = address.replace(`${splited[0]} `, '');
      for (let i = 0; i < prefs.length; i += 1) {
        if (newStr.startsWith(prefs[i])) newStr = newStr.replace(prefs[i], '');
      }
      return newStr;
    },

    /** 顧客のLINE USERを取得（operatorのPassengerCard.vueのthreadPassengerLineUserと判定を揃えること。#3692） */
    customerLineUser(customer) {
      return customer.user?.lineUser || customer.user?.lineUserUsers?.[0]?.lineUser || null;
    },

    /** クローンオブジェクトの返却 */
    getClone(object) {
      return cloneDeep(object);
    },

    /**
      * 3桁毎にカンマ割り振り
      * @param int num 元の数値
      */
    addComma(num, afterPoint = '', count = 0) {
      if (num !== 0 && !num) return '';
      // if (!this.isNumber(num)) return false;

      // 文字列にする
      let strNum = String(num);
      let afterDecimalPoint = afterPoint;
      if (strNum.includes('.')) {
        // 小数点以下を含む場合
        const split = strNum.split('.');
        strNum = split[0];
        afterDecimalPoint = `.${split[1]}`;
      }
      const len = Number(strNum.length);

      // 再帰的に呼び出し
      if (len > 3) {
        // 前半を引数に再帰呼び出し + 後半3桁
        strNum = `${this.addComma(strNum.substring(0, len - 3), afterDecimalPoint, count + 1)},${strNum.substring(len - 3)}`;
      }

      if (count === 0) {
        strNum += `${afterDecimalPoint}`;
      }

      return `${strNum}`;
    },

    // Objectから地点情報だけ抜き出す
    extractLocation(obj, keyPrefix, newKeyPrefix) {
      return {
        [`${newKeyPrefix}title`]: obj[`${keyPrefix}title`],
        [`${newKeyPrefix}address`]: obj[`${keyPrefix}address`],
        [`${newKeyPrefix}lat`]: obj[`${keyPrefix}lat`],
        [`${newKeyPrefix}lng`]: obj[`${keyPrefix}lng`],
        [`${newKeyPrefix}is_approximate`]: obj[`${keyPrefix}is_approximate`] ?? null,
      };
    },

    /** reservationのオブジェクトを表示に適した形に整形 */
    formatDemandReservation(rsv, colors) {
      // すべての地点情報を抽出（重複あり）
      const locationsAll = rsv.demandCustomers
        .map((customer, i) => ['p_', 'd_'].map((prefix) => ({
          isDemand: true,
          dc_id: customer.id,
          type: prefix === 'p_' ? 'pickup' : 'destination',
          user: customer.user,
          landmark_id: customer[`${prefix}landmark_id`],
          time: customer[`${prefix}datetime`],
          announce_datetime: customer[prefix === 'p_' ? 'datetime' : 'announce_datetime'],
          ...this.extractLocation(customer, prefix, ''),
          color: colors[i] || colors[colors.length - 1],
        })))
        .flat();

      // 時間順にソート
      locationsAll.sort((a, b) => {
        if (a.time < b.time) return -1;
        if (a.time > b.time) return 1;
        return 0;
      });

      // 同一地点で同一時間のものをまとめる
      const locationsMap = {};
      locationsAll.forEach((l) => {
        const key = `${l.lat},${l.lng},${l.time}`;
        if (!locationsMap[key]) {
          let displayTitle = l.title;
          const customer = rsv.demandCustomers.find((cus) => cus.id === l.dc_id);

          if (customer) {
            const landmarkLabel = l.type === 'pickup' ? customer.pLandmark?.landmark_label : customer.dLandmark?.landmark_label;
            if (landmarkLabel) {
              displayTitle = `${landmarkLabel} ${l.title}`;
            }
          }

          locationsMap[key] = {
            type: l.type,
            ...this.extractLocation(l, '', ''),
            title: displayTitle,
            time: l.time,
            customers: [],
          };
        }
        // 相乗り地点は誰か1人でも概算なら概算扱い（#3478）
        if (l.is_approximate === 1) locationsMap[key].is_approximate = 1;

        const customer = rsv.demandCustomers.find((cus) => cus.id === l.dc_id);
        locationsMap[key].customers.push({ ...customer, color: l.color, type: l.type });
      });

      return { ...rsv, locations: Object.values(locationsMap) };
    },

    /** dispatch => passengers => passengerLocations をフラットにして時間順に並べる */
    dispatchLocations(dispatch) {
      const passengers = dispatch.passengers || [];
      const locations = passengers.flatMap((p) => p.passengerLocations);
      return locations.sort((a, b) => new Date(a.datetime).getTime() - new Date(b.datetime).getTime());
    },

    assignedDemand(user) {
      if (!user?.demandSchedules?.length) return null;
      return user.demandSchedules[0];
    },

    /**
     * 事業所・ステータス名から表示用 HEX を返す
     */
    getStatusHex(officeId, statusName) {
      return this.$store.getters['helper/statusColorHex'](officeId, statusName);
    },
    /** flag 値から表示用 HEX を返す */
    getStatusHexByFlag(officeId, flagValue) {
      return this.$store.getters['helper/statusColorHexByFlagValue'](officeId, flagValue);
    },

    itemStatus(item, master) {
      const { type, raw } = item;
      let flags = [];
      if (type === 'reservation') {
        if (raw.foreign_type === 31) {
          const demandCustomers = raw.demandCustomers;
          flags = demandCustomers.map((dc) => dc.flag);
        } else {
          flags = raw.order ? [raw.order.flag] : [];
        }
      } else {
        flags = (raw.passengers || []).map((p) => p.flag);
      }
      const filteredFlags = flags.filter((f) => f < 31);
      const officeId = raw.office_id || this.$store?.state?.user?.offices?.[0]?.id || null;
      if (!filteredFlags.length) {
        return { isActive: false, color: master.colors?.gray || '#ADB5BD' };
      }
      const targetFlag = filteredFlags.reduce((a, c) => (a < c ? c : a), filteredFlags[0]);
      const colorHex = this.getStatusHexByFlag(officeId, targetFlag);
      return { isActive: true, color: colorHex };
    },
  },
};
